  <span class="rounded-circle avatar-withoout-img" [ngbTooltip]="tooltipText">
    {{ nickName }}
  </span>
  <span class="front-of-label" *ngIf="showFrontOf">{{tooltipText}}</span>
